import { useEffect, useState } from "react";
import {
  getProblemAttempts,
  PROBLEM_ATTEMPTS_CHANGED_EVENT,
  ProblemAttempts,
} from "../store/problemAttempts";

/** Saved problem attempts, refreshed when one is created or deleted (in this tab or another). */
export const useProblemAttempts = (): ProblemAttempts => {
  const [attempts, setAttempts] = useState<ProblemAttempts>(() => getProblemAttempts());

  useEffect(() => {
    const refresh = () => setAttempts(getProblemAttempts());
    // Pick up writes made between the first render and subscribing
    refresh();
    window.addEventListener(PROBLEM_ATTEMPTS_CHANGED_EVENT, refresh);
    window.addEventListener("storage", refresh);
    return () => {
      window.removeEventListener(PROBLEM_ATTEMPTS_CHANGED_EVENT, refresh);
      window.removeEventListener("storage", refresh);
    };
  }, []);

  return attempts;
};
